import {EntityModel} from "@fedeltapointofsale/data-client";
import {SalesJournalData} from "./sales-journal.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class SalesJournalEntityModel extends EntityModel<SalesJournalData> {
    constructor(injector: Injector) {
        super(injector, SalesJournalData);
    }
}
